import { Box, Typography } from '@mui/material';
import React from 'react';

import topImage from 'assets/images/help-item-search-top-nav.png';
import refineImage from 'assets/images/help-item-search-refine.png';
import filledImage from 'assets/images/help-item-search-filled.png';
import HelpImage from 'ui/help/HelpImage';

// TODO internationalize if we end up caring about it

const HelpMultiItemSearch = () => {
  return (
    <Box>
      <Typography variant='body1'>
        If you are hoping to search for multiple items at a time, such as a list
        of UPCs or item numbers, you can utilize the Item Search feature of this
        application. This can be used in combination with the regular keyword
        search or other search refinement options if you find that you want to
        narrow your search further. You can find the Item Search feature in the
        top navigation area near the search bar, or in the search refine panel,
        as shown below.
      </Typography>
      <HelpImage imageSrc={topImage} alt='top nav location' />
      <HelpImage imageSrc={refineImage} alt='refine section location' />
      <Typography variant='body1'>
        It is important to understand the 'delimiter' term to utilize this
        feature correctly. A delimiter is the divider between your search
        elements, so for example if you wanted to search for the item numbers
        1234567, 7654321, 456789, and 987654 that you pulled from a list where
        they are separated by spaces. You would want to choose the 'Space'
        delimiter option, and paste your values into the data box with spaces
        between each search term, as shown below.
      </Typography>
      <HelpImage imageSrc={filledImage} alt='filled in example' />
    </Box>
  );
};

export default HelpMultiItemSearch;
